export default __webpack_public_path__ + "15951bc27de00a9cf3a465bfc1670508.svg";